import { useLocale, useTranslate } from 'react-admin'

import type { EventMarker } from '@/data/source'

import { useEventName } from './useEventName'

export const useMarkerLabel = () => {
  const translate = useTranslate()
  const locale = useLocale()
  const eventName = useEventName()
  return (marker: EventMarker): string => {
    if (marker.type === 'PLACE') return marker.muelle ?? ''
    const product = marker.product?.trim()
    const name =
      product !== undefined && product !== ''
        ? product
        : translate('pages.scales.timeline.marker', { event: eventName({ ...marker, type: marker.type }), number: marker.number })
    return marker.quantityT === null ? name : `${name} (${marker.quantityT.toLocaleString(locale)})`
  }
}
